import { useTopStore } from '@/store/top'
import { BrandID } from '@/types/common/course'
import { addAssetsPublicPath } from '@/utils/env'
import { storeToRefs } from 'pinia'

export interface Course {
  brandID: BrandID
  icon?: string
  name?: string
  explanation?: string
  isNew?: boolean
}
export const BASE_COURSES: Course[] = [
  {
    brandID: BrandID.NONE,
    icon: addAssetsPublicPath('static/images/course/none/icon.svg'),
    name: '自動追加なし',
  },
  {
    brandID: BrandID.BTC,
    explanation: '注目のビットコインに連動を目指す',
  },
  {
    brandID: BrandID.ETH,
    explanation: 'ビットコインに次ぐイーサリアムに連動を目指す',
  },
  {
    brandID: BrandID.INVERSE_BTC,
    explanation: 'ビットコインとの逆連動を目指す',
    isNew: false,
  },
  {
    brandID: BrandID.INVERSE_ETH,
    explanation: 'イーサリアムとの逆連動を目指す',
    isNew: false,
  },
  {
    brandID: BrandID.ALL,
    icon: addAssetsPublicPath('static/images/course/all/icon.svg'),
    name: '全コース',
  },
  {
    brandID: BrandID.GOLD,
    explanation: '金でポイント運用',
  },
  {
    brandID: BrandID.TECHNOLOGY,
    explanation: 'GAFAM等に連動を目指す',
  },
  {
    brandID: BrandID.STANDARD,
    explanation: '米国の500企業で運用',
  },
  {
    brandID: BrandID.US_LONGTERM_CHALLENGE,
    explanation: '20年超の米国債価格に連動して3倍の値動きを目指す',
  },
  {
    brandID: BrandID.TECH_CHALLENGE,
    explanation: 'GAFAM等に連動して3倍の値動きを目指す',
  },
  {
    brandID: BrandID.CHALLENGE,
    explanation: '米国の500企業に連動して3倍の値動きを目指す',
  },
  {
    brandID: BrandID.REVERSE_TECH_CHALLENGE,
    explanation: 'GAFAM等に逆連動して3倍の値動きを目指す',
  },
  {
    brandID: BrandID.REVERSE_CHALLENGE,
    explanation: '米国の500企業に逆連動して3倍の値動きを目指す',
  },
]

const getCoursesWithNameIcon = () => {
  return BASE_COURSES.map((course) => {
    if (course.icon && course.name) return course
    const topStore = useTopStore()
    const { tmpBrands } = storeToRefs(topStore)
    return {
      ...course,
      icon: tmpBrands.value.find((brand) => brand.BRAND_ID === course.brandID)?.IMAGE_PATH,
      name: tmpBrands.value.find((brand) => brand.BRAND_ID === course.brandID)?.BRAND_NM,
    }
  })
}

export const findCourseByBrandID = (brandID: BrandID): Course => {
  return getCoursesWithNameIcon().find((course) => course.brandID === brandID)!
}

export const AutoAddAllScope = [
  BrandID.GOLD,
  BrandID.TECHNOLOGY,
  BrandID.STANDARD,
  BrandID.US_LONGTERM_CHALLENGE,
  BrandID.TECH_CHALLENGE,
  BrandID.CHALLENGE,
]

export function getAutoAddCourses(): Course[] {
  const topStore = useTopStore()
  const { tmpBrands } = storeToRefs(topStore)
  return getCoursesWithNameIcon().filter(
    (i) =>
      tmpBrands.value.map((brand) => brand.BRAND_ID).includes(i.brandID) ||
      i.brandID === BrandID.ALL ||
      i.brandID === BrandID.NONE,
  )
}
